var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _objectSpread = require("/app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var plugin = require('tailwindcss/plugin');
var baseStyles = {
  position: 'relative',
  paddingBottom: "calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%)"
};
var childStyles = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0'
};
var noneComponent = {
  '.aspect-none': {
    position: 'static',
    paddingBottom: '0'
  },
  '.aspect-none > *': {
    position: 'static',
    height: 'auto',
    width: 'auto',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }
};
var aspectRatio = plugin(function (_ref) {
  var _ref6;
  var addComponents = _ref.addComponents,
    matchComponents = _ref.matchComponents,
    theme = _ref.theme,
    variants = _ref.variants,
    e = _ref.e;
  var values = theme('aspectRatio');
  if (matchComponents) {
    matchComponents({
      'aspect-w': function aspectW(value) {
        return [_objectSpread(_objectSpread({}, baseStyles), {}, {
          '--tw-aspect-w': value
        }), {
          '> *': childStyles
        }];
      },
      'aspect-h': function aspectH(value) {
        return {
          '--tw-aspect-h': value
        };
      }
    }, {
      values: values
    });
    addComponents(noneComponent);
    return;
  }
  var baseSelectors = Object.entries(values).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return ".".concat(e("aspect-w-".concat(key)));
  }).join(',\n');
  var childSelectors = Object.entries(values).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return ".".concat(e("aspect-w-".concat(key)), " > *");
  }).join(',\n');
  addComponents([(_ref6 = {}, _defineProperty(_ref6, baseSelectors, baseStyles), _defineProperty(_ref6, childSelectors, childStyles), _ref6), noneComponent, Object.entries(values).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      value = _ref8[1];
    return _defineProperty({}, ".".concat(e("aspect-w-".concat(key))), {
      '--tw-aspect-w': value
    });
  }), Object.entries(values).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      key = _ref11[0],
      value = _ref11[1];
    return _defineProperty({}, ".".concat(e("aspect-h-".concat(key))), {
      '--tw-aspect-h': value
    });
  })], variants('aspectRatio'));
}, {
  theme: {
    aspectRatio: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12',
      13: '13',
      14: '14',
      15: '15',
      16: '16'
    }
  },
  variants: {
    aspectRatio: ['responsive']
  }
});
module.exports = aspectRatio;